import React, { Component } from 'react';
import { ObjectStatus } from '../ObjectStatus';
import { connect } from 'react-redux';
import { ltjsModule } from '@sas-dvr/ltjs-commons/ltjsEnvironment';
import { useI18n } from '../../locale/I18nContext';
import { selectLayoutState } from '../../store/selectors';
import { renderInlineCssVars } from '@sas/nova-commons/theme';
import cx from 'classnames';
import cn from './ErrorBoundary.css.json';
import './ErrorBoundary.css';
const ErrorStatus = (props) => {
    const localize = useI18n();
    let positionVars;
    if (props.position) {
        positionVars = {
            top: props.position.top !== undefined ? props.position.top + 'px' : undefined,
            left: props.position.left !== undefined ? props.position.left + 'px' : undefined,
            width: props.position.width !== undefined ? props.position.width + 'px' : undefined,
            height: props.position.height !== undefined ? props.position.height + 'px' : undefined,
        };
    }
    return (React.createElement("div", { className: cx(cn.container, props.className), style: Object.assign(Object.assign({}, renderInlineCssVars(positionVars, 'errorBoundary')), props.style) },
        React.createElement(ObjectStatus, { text: localize(props.errorMessageKey), mode: "error" })));
};
class EBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.onAbort = this.onAbort.bind(this);
        if (this.props.respondToWASMCrash) {
            ltjsModule.addAbortCallback(this.onAbort);
        }
    }
    componentWillUnmount() {
        if (this.props.respondToWASMCrash) {
            ltjsModule.removeAbortCallback(this.onAbort);
        }
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error) {
        console.error(error);
    }
    onAbort() {
        this.forceUpdate();
    }
    render() {
        if (this.state.hasError || (ltjsModule.wasmCrashed && this.props.respondToWASMCrash)) {
            return (React.createElement(ErrorStatus, { className: this.props.className, style: this.props.style, position: this.props.position, errorMessageKey: this.props.errorMessageKey }));
        }
        return this.props.children;
    }
}
export const ErrorBoundary = connect((state, props) => ({
    position: props.visualId ? selectLayoutState(state, props.visualId).position : undefined,
}))(EBoundary);
